"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a history singleton which can be imported from multiple sources
 */
var history_1 = require("history");
var history = history_1.createBrowserHistory();
exports.default = history;
